/**
 * @file use-plain-backdrop.ts
 * @description Убирает шёлковый фон кабинета (SC66) на время жизни
 * страницы, не трогая ширину (phase19.16, SB78 — дополнение к SC65:
 * «Оформление» и «Шапка и подвал» — рядом предпросмотр сайта в его цветах,
 * чужой фон мешает оценке). Вне каркаса `AppShell` ничего не делает.
 *
 * Отдельным файлом: файл компонента `AppShell.tsx` экспортирует только
 * компоненты и уже существующие хуки (правило fast refresh).
 */

import { useEffect } from "react";

import { useAppShellOptional } from "./AppShell";

export function usePlainBackdrop(on = true): void {
  const shell = useAppShellOptional();
  const setPlain = shell?.setPlain;
  useEffect(() => {
    if (!setPlain || !on) return;
    setPlain(true);
    return () => setPlain(false);
  }, [setPlain, on]);
}
